<template>
  <div class="col-12 grid-margin">
    <div
      id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading"
    >
      <p style="position: absolute; color: White; top: 40%; left: 50%;">
        <img src="../../assets/loader.gif" />
      </p>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Add a Turtle</h4>
        <form class="form-sample" @submit="onSubmit">
          <div class="col-md-6 pt-4 pb-4 pl-0">
            <div class="row">
              <div class="col-md-6 form-group" style="font-size:16px!important">
                <label for="exampleInputEmail1">Please Enter Turtle Image</label>
                <br />
                <input
                  type="file"
                  class="images"
                  accept="image/*"
                  id="file7"
                  ref="file7"
                  v-on:change="handleFileUpload7()"
                />

                <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
              </div>
              <div class="col-md-4">
                <div v-if="url7" width="80px" height="80px" class="card" id="preview">
                  <img width="100%" height="100%" :src="url7" />
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="font-size:16px!important">
            <div class="col-md-4 pb-2">
              <b-form-group label="Name">
                <b-form-input type="text" v-model="name" required></b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-4 pb-2">
              <b-form-group label="Scientific Name">
                <b-form-input type="text" v-model="sci_name" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4 pb-2">
              <b-form-group label="Common Name">
                <b-form-input type="text" v-model="common_name" required></b-form-input>
              </b-form-group>
            </div>
            <hr class="pt-2" />

            <div class="col-md-4">
              <b-form-group label="WLPA">
                <b-form-input type="text" v-model="wlpa"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Cites">
                <b-form-input type="text" v-model="cites"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="IUCN">
                <b-form-input type="text" v-model="iucn"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Morphology">
                <b-form-textarea
                  id="textarea4"
                  v-model="morphology"
                  placeholder="Morphology"
                  rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Color">
                <b-form-textarea id="textarea" v-model="color" placeholder="Color" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Dimorphism">
                <b-form-textarea
                  id="textarea1"
                  v-model="dimorphism"
                  placeholder="Dimorphism"
                  rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="size">
                <b-form-textarea id="textarea2" v-model="size" placeholder="Size" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Habitat">
                <b-form-textarea id="textarea5" v-model="habitat" placeholder="Habitat" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Diet">
                <b-form-textarea id="textarea6" v-model="diet" placeholder="Diet" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Nesting">
                <b-form-input type="text" v-model="nesting"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <label>Type</label>
              <select
                id="type"
                class="form-control"
                name="Chooae Type"
                required
                placeholder="Choose Type"
                v-model="type"
              >
                <option></option>
                <option value="Hard-Shell Turtle">Hard-Shell Turtle</option>
                <option value="Soft-Shell Turtle">Soft-Shell Turtle</option>
                <option value="Tortoise">Tortoise</option>
              </select>
            </div>

            <div class="col-md-4">
              <b-form-group label="Threats">
                <b-form-input type="text" v-model="threats"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="Distribution">
                <b-form-textarea
                  id="textarea10"
                  v-model="distribution"
                  placeholder="Distribution"
                  rows="5"
                ></b-form-textarea>
              </b-form-group>
            </div>
          </div>
          <h4 class="pt-5" style="font-size:24px!important">Uploading Images</h4>
          <div class="row pt-3">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Male Carapace</label>
                  <br />

                  <input
                    type="file"
                    class="images"
                    accept="image/*"
                    id="file1"
                    ref="file1"
                    v-on:change="handleFileUpload1()"
                  />
                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div id="preview">
                    <img width="60px" height="60px" v-if="url" :src="url" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Female Carapace</label>
                  <br />

                  <input
                    type="file"
                    class="images"
                    accept="image/*"
                    id="file2"
                    ref="file2"
                    v-on:change="handleFileUpload2()"
                  />

                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div id="preview">
                    <img width="60px" height="60px" v-if="url2" :src="url2" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Male Plastron</label>
                  <br />

                  <input
                    type="file"
                    class="images"
                    accept="image/*"
                    id="file3"
                    ref="file3"
                    v-on:change="handleFileUpload3()"
                  />

                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div id="preview">
                    <img width="60px" height="60px" v-if="url3" :src="url3" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Female Plastron</label>
                  <br />

                  <input
                    type="file"
                    class="images"
                    accept="image/*"
                    id="file4"
                    ref="file4"
                    v-on:change="handleFileUpload4()"
                  />

                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div id="preview">
                    <img width="60px" height="60px" v-if="url4" :src="url4" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Identification!</label>
                  <br />

                  <input
                    type="file"
                    class="images"
                    accept="image/*"
                    id="file5"
                    ref="file5"
                    v-on:change="handleFileUpload5()"
                  />

                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div id="preview">
                    <img width="60px" height="60px" v-if="url5" :src="url5" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Image of Identification2</label>
                  <br />

                  <input
                    type="file"
                    class="images"
                    accept="image/*"
                    id="file6"
                    ref="file6"
                    v-on:change="handleFileUpload6()"
                  />

                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div id="preview">
                    <img width="60px" height="60px" v-if="url6" :src="url6" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 pt-2">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="exampleInputEmail1">Please Enter Map Image</label>
                  <br />

                  <input
                    type="file"
                    class="images"
                    accept="image/*"
                    id="file8"
                    ref="file8"
                    v-on:change="handleFileUpload8()"
                  />

                  <!--input input type="file" :name="'images' + (index + 1)" accept="image/*" @change="previewImage(index, $event)"-->
                </div>
                <div class="col-md-4">
                  <div id="preview">
                    <img width="60px" height="60px" v-if="url8" :src="url8" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label for="exampleInputEmail1">More Images</label>
            <div class="input-group-prepend">
              <input
                type="file"
                accept="image/*"
                id="filearr"
                ref="files"
                multiple="multiple"
                @change="onFileChanged2"
              />
            </div>
          </div>
          <div class="row pt-3" id="preview">
            <div v-for="(item,i) in urlarr" :key="i" class="col-md-2">
              <img width="60px" height="60px" v-if="item" :src="item" />
              <i
                style="font-size:15px;padding-left:10px;"
                @click=" imgremove(item)"
                class="fa fa-close pb-0"
              ></i>
            </div>
          </div>

          <hr />
          <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "addaturtle",
  props: {
    caption: {
      type: String,
      default: "Add a Turtle"
    }
  },
  data: () => {
    return {
      loading: false,
      sci_name: "",
      name: "",
      common_name: "",
      type: "",
      cites: "",
      iucn: "",
      morphology: "",
      color: "",
      dimorphism: "",
      size: "",
      wlpa: "",
      habitat: "",
      diet: "",
      nesting: "",
      distribution: "",
      threats: "",
      female_carapace: "",
      male_carapace: "",
      male_plastron: "",
      female_plastron: "",
      identification1: "",
      identification2: "",
      turtleImage: "",
      mapImage: "",
      id: "",
      loading: false,
      file1: "",
      file2: "",
      file3: "",
      file4: "",
      file5: "",
      file6: "",
      file7: "",
      file8: "",
      url: null,
      url2: null,
      url3: null,
      url4: null,
      url5: null,
      url6: null,
      url7: null,
      url8: null,
      urlarr: [],
      turt: new FormData(),
      selectedFiles: null,
      id1: ""
    };
  },
  // mounted: function () {
  //   this.loadStats()
  // },
  methods: {
    handleFileUpload1() {
      this.file1 = this.$refs.file1.files[0];
      this.url = URL.createObjectURL(this.file1);
    },
    handleFileUpload2() {
      this.file2 = this.$refs.file2.files[0];
      this.url2 = URL.createObjectURL(this.file2);
    },
    handleFileUpload3() {
      this.file3 = this.$refs.file3.files[0];
      this.url3 = URL.createObjectURL(this.file3);
    },
    handleFileUpload4() {
      this.file4 = this.$refs.file4.files[0];
      this.url4 = URL.createObjectURL(this.file4);
    },
    handleFileUpload5() {
      this.file5 = this.$refs.file5.files[0];
      this.url5 = URL.createObjectURL(this.file5);
    },
    handleFileUpload6() {
      this.file6 = this.$refs.file6.files[0];
      this.url6 = URL.createObjectURL(this.file6);
    },
    handleFileUpload7() {
      this.file7 = this.$refs.file7.files[0];
      this.url7 = URL.createObjectURL(this.file7);
    },
    handleFileUpload8() {
      this.file8 = this.$refs.file8.files[0];
      this.url8 = URL.createObjectURL(this.file8);
    },

    imgremove(index) {
      this.urlarr.splice(index, 1);
    },
    onFileChanged2(event) {
      this.selectedFiles = event.target.files[0];
      this.turt.append("image", this.selectedFiles);
      console.log("files", this.turt);
      var img;
      img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        const urls = URL.createObjectURL(this.selectedFiles);
        if (this.urlarr.length < 4) {
          this.urlarr.push(urls);
        } else {
          this.seen = false;
          this.msg = "Four Images Already Added!";
          this.showsnackbar = true;
        }
        console.log("urls", urls);
        console.log("urlarr", this.urlarr);
        console.log("turt", this.turt);

        // console.log( this.url1)
        // this.uploadImage();
      };
    },
    onSubmit(evt) {
      evt.preventDefault();
      var add = {};
      add["name"] = this.name;
      add["common_name"] = this.common_name;
      add["sci_name"] = this.sci_name;
      add["type"] = this.type;
      add["cites"] = this.cites;
      add["wlpa"] = this.wlpa;
      add["iucn"] = this.iucn;
      add["morphology"] = this.morphology;
      add["color"] = this.color;
      add["dimorphism"] = this.dimorphism;
      add["size"] = this.size;
      add["habitat"] = this.habitat;
      add["diet"] = this.diet;
      add["nesting"] = this.nesting;
      add["distribution"] = this.distribution;
      add["threats"] = this.threats;
      add["x-auth-token"] = localStorage.getItem("token");
      axios({
        method: "post",
        url: "/turtle/add",
        data: add
      })
        .then(response => {
          this.msg = response.data.msg;
          this.id = response.data._id;
          this.loading = "false";
          if (response.data.status === true) {
            this.id1 = response.data.data._id;
            //let formData = new FormData();
            this.turt.append("token", localStorage.getItem("token"));
            this.turt.append("id", this.id1);
            this.turt.append("male_carapace", this.file1);
            this.turt.append("female_carapace", this.file2);
            this.turt.append("male_plastron", this.file3);
            this.turt.append("female_plastron", this.file4);
            this.turt.append("identification1", this.file5);
            this.turt.append("identification2", this.file6);
            this.turt.append("turtleImage", this.file7);
            this.turt.append("mapImage", this.file8);
            console.log("file", this.file7);
            this.loading = true;

            axios({
              method: "post",
              url: "/turtle/uploadImagesingle",
              data: this.turt,
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
              .then(response => {
                this.$router.push({ path: "/listturtles" });
              })

              .catch(e => {
                console.log(e);
                this.loading = false;
              });
          }
          if (response.data.status === false) {
            alert(response.data.msg);
            this.loading = false;
            this.$router.push({ path: "/addaturtle" });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>